import keymirror from 'keymirror';
import { request } from 'js/api/axios';

import { spreadApiKeys, extractApiKeys } from '../utils';
import { callApi, noSchemaQuerySuccessMutator } from '../api';

export const types = keymirror({
  ...spreadApiKeys('LIST_JIRA_BOARDS'),
  ...spreadApiKeys('LIST_JIRA_PROJECTS'),
  ...spreadApiKeys('QUERY_ISSUE_FIELDS'),
});

export function listJiraBoards(connectorId, queryId = null) {
  const meta = { queryId };
  return (dispatch) => {
    return callApi(
      {
        types: extractApiKeys(types.LIST_JIRA_BOARDS, types),
        request: (_data, token, currentWorkspaceId) =>
          request.get(
            `/api/workspaces/${currentWorkspaceId}/connectors/${connectorId}/jira/boards`,
            {
              headers: {
                Authorization: `Bearer ${token}`,
              },
            }
          ),
        meta,
        mutators: [undefined, noSchemaQuerySuccessMutator(meta), undefined],
      },
      dispatch
    );
  };
}

export function listJiraProjects(workspaceId, connectorId, queryId = null) {
  const meta = { queryId };
  return (dispatch) => {
    return callApi(
      {
        types: extractApiKeys(types.LIST_JIRA_PROJECTS, types),
        request: (_data, token) =>
          request.get(
            `/api/workspaces/${workspaceId}/connectors/${connectorId}/jira/projects`,
            {
              headers: {
                Authorization: `Bearer ${token}`,
              },
            }
          ),
        meta,
        mutators: [undefined, noSchemaQuerySuccessMutator(meta), undefined],
      },
      dispatch
    );
  };
}

export function queryIssueFields(connectorData) {
  return (dispatch) => {
    return callApi(
      {
        types: extractApiKeys(types.QUERY_ISSUE_FIELDS, types),
        request: (data, token, currentWorkspaceId) => {
          console.log('💣 queryIssueFields', data, token, currentWorkspaceId);
          return request.post(
            `/api/workspaces/${currentWorkspaceId}/connectors/jira/issue-fields`,
            data,
            { headers: { Authorization: `Bearer ${token}` } }
          );
        },

        data: { connector: connectorData },
        mutators: [undefined, noSchemaQuerySuccessMutator({}), undefined],
      },
      dispatch
    );
  };
}

export function queryIssueFieldsForConnector(connectorId, connectorOverrides) {
  return (dispatch) => {
    return callApi(
      {
        types: extractApiKeys(types.QUERY_ISSUE_FIELDS, types),
        request: (data, token, currentWorkspaceId) => {
          console.log('💣 queryIssueFields', data, token, currentWorkspaceId);
          return request.post(
            `/api/workspaces/${currentWorkspaceId}/connectors/${connectorId}/jira/issue-fields`,
            data,
            { headers: { Authorization: `Bearer ${token}` } }
          );
        },

        data: { connector: connectorOverrides },
        mutators: [undefined, noSchemaQuerySuccessMutator({}), undefined],
      },
      dispatch
    );
  };
}
